import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum OfferStateId {
  ACTIVE = 1,
  RESERVED = 2,
  CONCEPT = 3,
  EXPIRED = 4,
  CANCELLED = 5,
}

export class OfferState extends Codebook<OfferStateId> {
  static readonly ACTIVE = new OfferState(OfferStateId.ACTIVE, () => $t('Active'), Color.INFO)
  static readonly RESERVED = new OfferState(
    OfferStateId.RESERVED,
    () => $t('Reserved'),
    Color.POSITIVE,
  )
  static readonly CONCEPT = new OfferState(OfferStateId.CONCEPT, () => $t('Concept'), Color.WARNING)
  static readonly EXPIRED = new OfferState(
    OfferStateId.EXPIRED,
    () => $t('Expired'),
    Color.GREY_600,
  )
  static readonly CANCELLED = new OfferState(
    OfferStateId.CANCELLED,
    () => $t('Cancelled'),
    Color.NEGATIVE,
  )

  private constructor(
    id: OfferStateId,
    public readonly name: () => string,
    public readonly color:
      | Color.POSITIVE
      | Color.WARNING
      | Color.NEGATIVE
      | Color.INFO
      | Color.GREY_600,
  ) {
    super(id)
  }

  public equals = (other: OfferState): boolean => {
    return this.id === other.id
  }
}
